// extracted by mini-css-extract-plugin
module.exports = {"printEvaluationNew":"printEvaluationNew___19Yx8"};